import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'

import { EuiPage, EuiPanel, EuiTitle, EuiPageHeaderSection, EuiPageBody, EuiPageHeader } from '@elastic/eui'

import { updateAccountState, showSuccessToast } from 'app/appSlice'

import history from '../../services/HistoryService'
import { ClientDetailsForm } from './ClientDetailsForm'

export const CreateClientPage = () => {
  const dispatch = useDispatch()

  return (
    <EuiPage className='euiPage--platform'>
      <EuiPageBody>
        <Helmet>
          <h1>Create Client</h1>
        </Helmet>
        <EuiPageHeader>
          <EuiPageHeaderSection>
            <EuiTitle>
              <h1>Create Client</h1>
            </EuiTitle>
          </EuiPageHeaderSection>
        </EuiPageHeader>
        <EuiPanel grow={false} className='eui-xScroll'>
          <ClientDetailsForm
            isNewAccount={true}
            onSubmit={account => {
              dispatch(updateAccountState(account))
              dispatch(showSuccessToast('Created Account'))
              history.push('/dashboard')
            }}
          />
        </EuiPanel>
      </EuiPageBody>
    </EuiPage>
  )
}
